// Vue
import {mixins} from 'vue-class-component'
import {Component, Prop, Inject, Watch} from 'vue-property-decorator'
// Template
import template from './template.vue'
// Components
import {Icon} from './../icon/Icon'
// Mixins
import {FormInput} from './../../../mixins/form_input/FormInput'
@Component({
    name: 'Checkbox',
    components: {Icon},
    mixins: [
        template,
    ]
})
export class Checkbox extends mixins(FormInput) {

    @Prop({default: false})
    public value!: boolean

    @Prop([String, Number])
    public trueValue!: any

    @Prop()
    public theme!: string

    @Inject({ from: 'checkboxGroupTheme', default: null})
    public parentTheme!: string

    @Inject({ from: 'checkboxGroupDisabled', default: false})
    public parentDisabled!: boolean

    @Prop()
    public header?: string

    @Prop()
    public label?: string

    @Prop()
    public img!: string

    @Prop()
    public info?: string

    @Prop({default: false})
    public disabled!: boolean

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop({default: true})
    public showErrors!: boolean

    @Prop()
    public id!: string

    @Prop()
    public name!: string

    @Prop({default: "0"})
    public tabindex!: string

    private isChecked: boolean = false;

    public get themeMap() {
        if ( this.theme == 'secondary' || this.parentTheme == 'secondary')
        {
            return 2
        }
        return 1
    }

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null)
    }

    public get themeClass() {
        return `${this.$appPrefix}-checkbox--${this.theme ? this.theme : 'default'} wb-e-check-${this.themeMap}`
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0 ? `${this.$appPrefix}-checkbox--error wb-e-check-${this.themeMap}--has-error` : ''
    }

    public get disabledClass() {

        return this.disabled || this.parentDisabled ? `${this.$appPrefix}-checkbox--disabled wb-e-check-${this.themeMap}--disabled` : ''
    }

    public get iconCheckboxClass() {
        return this.$slots['checked'] || this.$slots['unchecked'] ? `${this.$appPrefix}-checkbox--icon-checkbox`: ''
    }

    private get checkboxImgStyle() {
        return this.img ? 'display: block;' : ''
    }

    @Watch('value')
    private onValueChange() {
        this.isChecked = this.value;
    }

    public created() {
        this.$on('change', this.handleCheckboxGroupValueChange)
        this.$on('selectAll', this.handleSelectAll)
        this.isChecked = this.value;
    }

    public destroyed() {
        this.$off('change', this.handleCheckboxGroupValueChange)
        this.$off('selectAll', this.handleSelectAll)
    }

    private handleCheckboxGroupValueChange(value: any[]) {
        let values = value || []

        let isChecked = values.includes(this.trueValue)
        if (this.isChecked != isChecked) {
            this.isChecked = isChecked;
            this.$emit('input', isChecked);
        }
    }

    public handleSelectAll(value) {
        this.isChecked = value;
        this.$emit('input', value);
        this.dispatch('CheckboxGroup', 'change', [value, this.trueValue])
    }

    public handleChange(e) {
        this.isChecked = e.target.checked;
        this.$emit('input', e.target.checked)
        this.dispatch('CheckboxGroup', 'change', [e.target.checked, this.trueValue])
    }
}